<template>
  <div class="container" @mouseleave="hoverout()">
    <div class="d-flex justify-content-between align-items-end">
      <b-navbar-brand class="m-0">
        <cookie-section class="d-none d-lg-flex" />
        <a href="https://www.starbucksglobalacademy.com" class>
          <img
            src="../assets/images/logo.svg"
            alt
            srcset
            class="mt-lg-4 pb-3 pt-3 logo"
          />
        </a>
      </b-navbar-brand>
      <ul class="d-flex m-0 mt-4 no-list-bullets p-0 nav-list--pages">
        <li
          v-for="(link, i) in navigation.links"
          :key="`${link.name}-${i}`"
          class="pt-2 nav-list pb-2"
          @mouseenter="hovered(i)"
          :id="`link-menu-${i}`"
          :class="{
            'is-submenu': link.submenu,
            'current-website--active': link.active,
            'main-acive': link.active
          }"
        >
          <a class="nav-link" :href="link.sumenu ? '#' : link.url">
            {{ link.name }}
          </a>
          <div
            class="submenu bg-brand-dark-green submenu-container "
            v-if="link.submenu"
          >
            <div class="container">
              <ul class="d-flex no-list-bullets py-3 px-0">
                <li
                  v-for="(submenu, i) in link.submenu"
                  :key="i"
                  class="d-flex align-items-center"
                >
                  <a
                    :href="submenu.url"
                    :class="{
                      'current-acive-route':
                        $router.history.current.path === submenu.url
                    }"
                    class="text-white font-16 submenu-link"
                    >{{ submenu.name }}</a
                  >
                  <span
                    v-if="
                      link.submenu.length > 1 && i != link.submenu.length - 1
                    "
                    class="text-white px-3 submenu-link"
                    >|</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <ul class="no-list-bullets pb-2 pt-3 pl-0">
        <my-button
          :varient="'outline-inverted'"
          :reference="navigation.cta[0].baseUrl"
          type="button"
          class="font-16"
          :trackEventLink="{
            event: 'link',
            name: 'onclick',
            action: 'click',
            type: 'internal link',
            region: 'navbar',
            section: 'sticky navigation',
            text: 'sign in'
          }"
          >{{ navigation.cta[0].name }}</my-button
        >
        <my-button
          :varient="'outline-inverted-active ml-2 d-inline'"
          class="font-16"
          :reference="$store.state.signInUrls[this.$store.state.Dregion] + '/login?next=%2F'"
          :trackEventLink="{
            event: 'link',
            name: 'onclick',
            action: 'click',
            type: 'internal link',
            region: 'navbar',
            section: 'sticky navigation',
            text: 'all courses'
          }"
          type="button"
          >{{ navigation.cta[1].name }}</my-button
        >
      </ul>
    </div>
    <!-- Center navigation -->
  </div>
</template>

<script>
import myButton from "./base-button";
import cookieSection from "./cookieSection";
export default {
  props: {
    navigation: Object
  },
  methods: {
    hovered(i) {
      [...document.querySelectorAll(".nav-list")].forEach(element => {
        element.classList.remove("current-website--active");
      });
      document
        .getElementById(`link-menu-${i}`)
        .classList.add("current-website--active");
    },
    hoverout() {
      [...document.querySelectorAll(".nav-list")].forEach(element => {
        element.classList.remove("current-website--active");
      });
      setTimeout(() => {
        document
          .getElementsByClassName("main-acive")[0]
          .classList.add("current-website--active");
      }, 1);
    }
  },
  components: {
    myButton,
    cookieSection
  }
};
</script>

<style lang="scss">
.logo {
  width: 15rem;
  @media only screen and (max-width: 767px) {
    width: 12rem;
  }
}
.no-list-bullets {
  list-style: none !important;
  .submenu-link {
    opacity: 0.4;
  }
  .current-acive-route {
    opacity: 1 !important;
    text-decoration: underline;
  }
}
.bg-brand-dark-green {
  background-color: #29413b;
}
.font-16 {
  font-size: 19px;
}
</style>
